module.exports = __webpack_public_path__ + "static/services-main-d17e333875524f2257219ecb8d6fea6c.jpg";